<template>
  <div class="page-container-summary">
    <LandingBar active="help"/>
    <div class="buy-wrapper">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="summary-upper">
        <div class="summary-left">
          <h1 class="table-headline">Tutorial</h1>
          <div class="help-subheadline">New to EFLEX? Get started with EFLEX video tutorials or download our manual instruction</div>
          <div class="balance-flex">
              <div class="help-video-wrapper">
                  <img src="../img/Video1.png" alt="video" class="help-video">
                  <div class="help-text-wrapper">
                      <div class="help-headline">Video Tutorial 1</div>
                      <div class="help-text">Lorem ipsum dolor sit amet consectetur</div>
                  </div>
              </div>
              <div class="help-video-wrapper">
                  <img src="../img/Video2.png" alt="video" class="help-video">
                  <div class="help-text-wrapper">
                      <div class="help-headline">Video Tutorial 2</div>
                      <div class="help-text">Lorem ipsum dolor sit amet consectetur</div>
                  </div>
              </div>
          </div>
        </div>
        <div class="summary-right">
          <v-btn href="https://www.dropbox.com/s/t841wwfunlc72wq/Eflex_User_Manual.pdf?dl=0" elevation="2" color="#59c26b" class="transfer-button">
            Download manual instruction</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandingBar from "../components/Common/LandingBarDSO.vue";
import SummaryChart from "../components/Charts/SummaryChart";
import { mdiScaleBalance, mdiCurrencyEur, mdiRepeat } from "@mdi/js";

export default {
  components: { LandingBar, SummaryChart },
  data() {
    return {
      icons: {
        mdiScaleBalance,
        mdiCurrencyEur,
        mdiRepeat,
      },
      bread: [
        {
          text: "Help",
          disabled: false,
        },
        {
          text: "Tutorial",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    userHistory() {
      this.Apps.userHistory();
    },
    offerHistory() {
      this.Apps.offerHistory();
    },
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.page-container-summary {
  min-height: 100vh;
  background: #f8fcff;
  padding-bottom: 50px;
  margin-top: -100px;
}

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #f8fcff;
}

.balance-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 10px;
}

.balance1 {
  flex: 1;
  display: flex;
  padding: 20px;
  position: relative;
  flex-direction: column;
  margin-bottom: 20px;
  border-radius: 10px;
  background: rgba(38, 56, 88, 1);
  background: -moz-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(38, 56, 88, 1)),
    color-stop(57%, rgba(38, 56, 88, 1)),
    color-stop(75%, rgba(71, 87, 115, 1)),
    color-stop(100%, rgba(153, 164, 180, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#263858', endColorstr='#99a4b4', GradientType=1 );
}

.summary-icon {
  color: #fff !important;
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.summary-header {
  color: #fff;
}

.balance {
  margin: 20px 0;
  font-size: 1.3em;
  color: #fff;
  font-weight: 700;
}

.conversion {
  font-size: 0.8em;
  color: #999;
}

.summary-upper {
  display: flex;
  justify-content: space-between;
}

.summary-left,
.summary-right {
  width: 48%;
  display: flex;
  flex-direction: column;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.summary-middle {
  display: flex;
  margin: 60px 0;
}

.summary-graph {
  flex: 1;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0);
  padding: 0 20px;
  overflow-x: hidden;
}

.summary-middle-table {
  width: 50%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.buy-wrapper th {
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.buy-wrapper td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.transactions {
  width: 100%;
}

.table-headline2 {
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
}

.help-subheadline {
    font-size: 20px;
    margin-bottom: 40px;
}

.help-video-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
}

.help-text-wrapper {
    margin-left: 50px;
}

.help-headline {
    font-size: 28px;
    margin-bottom: 20px;
}

.help-video {
  width: 350px;
  cursor: pointer;
}
</style>
